import { z } from '../zod';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';
import { ProductDetailsInputValidationSchema, SinglePriceInputValidationSchema } from './create';
import { orderBumpCardInputFields } from './orderBumpCard';

const createShape = ProductDetailsInputValidationSchema.shape;

const createProductBodyShape = {
  role: z.literal('orderbump').meta({
    description:
      'Must be `orderbump`: only order bump products are created on their own. A page product is created with its page (create_checkout_page, create_event).',
    example: 'orderbump',
  }),
  title: z.string().trim().min(1).max(200).meta({
    description: 'Product title, shown on the order bump card.',
    example: 'Gift wrapping',
  }),
  description: createShape.description,
  price: SinglePriceInputValidationSchema.optional().meta({
    description:
      'The order bump price. Order bumps use a one-time price, which can be pay what you want: recurring prices and payment plans are not available. Defaults to a one-time price of 0 in `usd`.',
  }),
  sku: createShape.sku,
  hasUnlimitedStock: createShape.hasUnlimitedStock,
  stock: createShape.stock,
  taxBehavior: createShape.taxBehavior,
  taxCode: createShape.taxCode,
  fixedTaxRateIds: z.array(ObjectIdStringValidationSchema).max(1).optional().meta({
    description:
      'Tax Rate IDs applied to this product (at most one). Call `list_tax_rates` to find an existing rate.',
  }),
  imageIds: z.array(ObjectIdStringValidationSchema).optional().meta({
    description:
      'Image file IDs for the product (upload with `upload_file`). The first is shown on the card.',
  }),
  fileIds: createShape.fileIds,
  ...orderBumpCardInputFields,
};

export const CREATE_PRODUCT_FIELDS = Object.keys(createProductBodyShape) as ReadonlyArray<
  keyof typeof createProductBodyShape
>;

export const CreateProductRequestValidationSchema = z
  .object(createProductBodyShape)
  .strict()
  .meta({ id: 'CreateProductRequest' });

export const CreateProductInputValidationSchema = z.object(createProductBodyShape);

export type CreateProductInput = z.infer<typeof CreateProductInputValidationSchema>;
